import set from 'lodash/set';

import initialState from './state';

export default {
  addSku(state, concept) {
    set(concept, 'id', null);
    set(concept, 'rowId', state.catalogs.sku.length + 1);
    state.catalogs.sku.unshift(concept);
  },
  setSkuId(state, { sku, id }) {
    set(sku, 'id', id);
  },
  deleteConcept(state, { id }) {
    const index = state.catalogs.sku
      .findIndex(product => product.id === id);
    state.catalogs.sku.splice(index, 1);
  },
  setValue(state, { accessor, value }) {
    set(state, accessor, value);
  },
  setValues(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },
  setInitialState(state) {
    set(state, '', initialState);
  },
  addNotification(state, payload) {
    const notification = payload;
    if (!notification.dateTime) notification.dateTime = new Date();
    state.notifications.push(notification);
  },
  deleteNotification(state, payload) {
    const newNotifications = state.notifications.filter(notification => (
      notification.dateTime !== payload
    ));
    set(state, 'notifications', newNotifications);
  },
  setLogo(state, logo) {
    state.logo = logo;
  },
  setLogoWhite(state, logo) {
    state.logoWhite = logo;
  },
  addActiveMenu(state, payload) {
    if (!state.activeMenus.includes(payload)) state.activeMenus.push(payload);
  },
  deleteActiveMenu(state, payload) {
    const newMenus = state.activeMenus.filter(current => payload !== current);
    set(state, 'activeMenus', newMenus);
  },
  clearState(state) {
    state.notifications = [];
    state.activeMenus = [];
  },
  cleanSKuCatalog(state) {
    state.catalogs.sku = [];
  },
  pushEntriesCatalog(state, { catalog, entries }) {
    const selectedCatalog = state.catalogs[catalog];

    if (selectedCatalog) {
      entries.forEach((entry) => {
        const exists = selectedCatalog.find(current => current.value === entry.value);

        if (!exists) selectedCatalog.push(entry);
      });
    }
  },
};
